/* eslint-disable
    no-useless-escape,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
angular.module('unergie.main')
.filter('parseUrl', ($sce, $sanitize) => {
    const urlPattern = /(http|ftp|https):\/\/[\w-]+(\.[\w-]+)+([\w.,@?^=%&amp;:\/~+#-]*[\w@?^=%&amp;\/~+#-])?/gi
    return function (string) {
        const text = $sanitize(string)
        return $sce.trustAsHtml(text.replace(urlPattern, '<a style="text-decoration: underline;" target="_blank" href="$&">$&</a>'))
    }
})
